export const API_URL = "https://api2.neuroredes.4biz.dev.br/api/";
//export const API_URL = "https://api2.neuroredes.com.br/api/";